import { z } from 'zod';

export const AddReviewerFormSchema = z.object({
  reviewer: z.object(
    {
      label: z.string(),
      value: z.string(),
    },
    { message: 'กรุณาเลือก Reviewer' },
  ),
  dueDate: z.date({ message: 'กรุณาเลือก Due Date' }),
  description: z.string().optional(),
});

export type AddReviewerFormValues = z.infer<typeof AddReviewerFormSchema>;
